const Divider = ({
  orientation = "horizontal",
  className = ""
}: {
  orientation?: "vertical" | "horizontal";
  className?: string;
}) => {
  return orientation === "vertical" ? <hr aria-orientation='vertical' className={`box-content h-full overflow-visible border-l border-r-0 border-inherit text-inherit opacity-60 ${className}`} data-sentry-component="Divider" data-sentry-source-file="Divider.tsx" /> : <hr aria-orientation='horizontal' className={`box-content h-0 w-full overflow-visible border-b border-t-0 border-inherit text-inherit opacity-60 ${className}`} data-sentry-component="Divider" data-sentry-source-file="Divider.tsx" />;
};
export default Divider;